import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import SpecialText from "../components/SpecialText";
import ClickableCategoryHexagon from "../components/ClickableCategoryHexagon";
import { useTranslation } from "react-i18next";
import { CGI_GRADIENT_A_45DEG } from "../helpers/enums";
import { Box, Button, Typography } from "@mui/material";

export default function CustomerPreferences({
  setPage,
  selectedPreferences,
  setSelectedPreferences,
}) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        mt: 5,
      }}
    >
      <Typography sx={{ fontSize: 40, fontWeight: 500, userSelect: "none" }}>
        {t("pleaseSelect")}{" "}
        <SpecialText
          style={{
            background: CGI_GRADIENT_A_45DEG,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {t("areas")}
        </SpecialText>
        {"\n"}
        {t("youAreInterestedIn")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", mt: 6 }}>
          <ClickableCategoryHexagon
            category={t("security")}
            selectedPreferences={selectedPreferences}
            setSelectedPreferences={setSelectedPreferences}
          />
          <ClickableCategoryHexagon
            category={t("ai")}
            selectedPreferences={selectedPreferences}
            setSelectedPreferences={setSelectedPreferences}
          />
          <ClickableCategoryHexagon
            category={t("testAutomation")}
            selectedPreferences={selectedPreferences}
            setSelectedPreferences={setSelectedPreferences}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            mt: { xs: -1.5, md: -3 },
          }}
        >
          <ClickableCategoryHexagon
            category={t("cloud")}
            selectedPreferences={selectedPreferences}
            setSelectedPreferences={setSelectedPreferences}
          />
          <ClickableCategoryHexagon
            category={t("esg")}
            selectedPreferences={selectedPreferences}
            setSelectedPreferences={setSelectedPreferences}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: 1,
            mt: 9,
          }}
        >
          <Button
            size="small"
            variant="outlined"
            sx={{ borderRadius: 20 }}
            startIcon={<NavigateBeforeIcon />}
            onClick={() => setPage(0)}
          >
            {t("back")}
          </Button>
          <Button
            size="small"
            variant="contained"
            sx={{ borderRadius: 20 }}
            endIcon={<NavigateNextIcon />}
            onClick={() => setPage(2)}
          >
            {t("next")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
